// shared/src/oracle/tool-cache-stats-schema.ts
// Zod HTTP-parse contract for GET /api/oracle/cache-stats (P2.5 5.4). The oracle dashboard
// parses the response with THIS (C035: a server field not behind a Zod guard would read as
// undefined). The shape mirrors the ToolCacheStats RPC interface (scheduler-rpc.ts) — the
// parity guard below fails tsc if the two ever drift.

import { z } from 'zod';
import type { ToolCacheStats } from '../types/scheduler-rpc.js';

export const OracleCacheStatsSchema = z.object({
  generated_at: z.string(),
  total:        z.number(),
  fresh:        z.number(),
  stale:        z.number(),
  unknown:      z.number(),
  oldest_age_s: z.number().nullable(),
  by_tool:      z.array(z.object({ tool: z.string(), count: z.number() })),
  truncated:    z.boolean(),
});

export type OracleCacheStats = z.infer<typeof OracleCacheStatsSchema>;

// Parity guard: a value parsed by the Zod schema MUST satisfy the RPC interface. A field
// renamed/removed/retyped on either side makes this assignment fail tsc.
const _parity: ToolCacheStats = {} as OracleCacheStats;
void _parity;
